var render = function render(_c,_vm){return _c('ul',_vm._l((_vm.props.rows),function(row){return _c('div',{key:row.key,staticClass:"tiled-row",style:({height: `${row.height}px`})},_vm._l((row.items),function(item){return _c('li',{key:item.id,style:({ width: item.ratio ? `${row.height * item.ratio}px` : '100%', height: `${row.height}px`})},[_vm._t("default",null,{"row":row,"item":item})],2)}),0)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }